import { Image } from '@chakra-ui/react';
import React from 'react';
import { ArrowStyle } from './style';

function SlideArrow( props: any) {

  const { className, onClick, color } = props;

  return (
    <ArrowStyle
      className={className}
      onClick={onClick}
    >
      {
        className.includes('prev') && (
          <Image src={`/images/icons/arrow_left${color ? `_${color}` : ''}.svg`} />
        )
      }
      {
        className.includes('next') && (
          <Image src={`/images/icons/arrow_right${color ? `_${color}` : ''}.svg`} />
        )
      }
    </ArrowStyle>
  );
}

SlideArrow.defaultProps = {
};

export default SlideArrow;
